import Badge from "ds/components/Badge";

type MainNavigationBetaIndicatorProps = {
  className?: string;
};

const MainNavigationBetaIndicator = ({ className }: MainNavigationBetaIndicatorProps) => {
  return <Badge variant="blue" text="BETA" type="strong" className={className} />;
};

export default MainNavigationBetaIndicator;
